$(document).ready(function() {
    $(".rd-slickslider-full").slick({
        infinite: !0,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        dots: !0,
        arrows: !1,
        prevArrow: '<div class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
        nextArrow: '<div class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>'
    }), $(".rd-slickslider-2").slick({
        infinite: !0,
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 300,
        dots: !1,
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    }), $(".rd-slickslider-3").slick({
        infinite: !0,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 300,
        dots: !1,
        prevArrow: '<div class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="12.158" height="11.85" viewBox="0 0 12.158 11.85"><path d="M6.985,13.7l-.6.6a.649.649,0,0,1-.92,0L.188,9.034a.649.649,0,0,1,0-.92L5.463,2.839a.649.649,0,0,1,.92,0l.6.6a.652.652,0,0,1-.011.931L3.7,7.487h7.8a.65.65,0,0,1,.651.651v.868a.65.65,0,0,1-.651.651H3.7l3.27,3.115A.647.647,0,0,1,6.985,13.7Z" transform="translate(0.004 -2.647)" fill="#fff"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="12.158" height="11.85" viewBox="0 0 12.158 11.85"><path d="M6.985,13.7l-.6.6a.649.649,0,0,1-.92,0L.188,9.034a.649.649,0,0,1,0-.92L5.463,2.839a.649.649,0,0,1,.92,0l.6.6a.652.652,0,0,1-.011.931L3.7,7.487h7.8a.65.65,0,0,1,.651.651v.868a.65.65,0,0,1-.651.651H3.7l3.27,3.115A.647.647,0,0,1,6.985,13.7Z" transform="translate(0.004 -2.647)" fill="#fff"/></svg></div>',
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: !0
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    }), $(".rd-slickslider-4").slick({
        infinite: !0,
        slidesToShow: 4,
        slidesToScroll: 1,
        speed: 300,
        dots: !1,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: !0
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    }), $(".rd-slickslider-7").slick({
        infinite: !0,
        slidesToShow: 6,
        slidesToScroll: 1,
        speed: 300,
        dots: !1,
        prevArrow: '<div class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
        nextArrow: '<div class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
        responsive: [{
            breakpoint: 1299,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    }), $(".rd-slickslider-8").slick({
        infinite: !0,
        slidesToShow: 7,
        slidesToScroll: 1,
        speed: 300,
        dots: !1,
        prevArrow: '<div class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
        nextArrow: '<div class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
        responsive: [{
            breakpoint: 1299,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    }), $(".rd-slickslider-9").slick({
        infinite: !0,
        slidesToShow: 8,
        slidesToScroll: 1,
        speed: 300,
        dots: !1,
        prevArrow: '<div class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
        nextArrow: '<div class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
        responsive: [{
            breakpoint: 1299,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 991,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    }), $(".rd-slickslider-10").slick({
        infinite: !0,
        slidesToShow: 10,
        slidesToScroll: 1,
        speed: 1e3,
        dots: !1,
        arrows: !1,
        autoplay: !0,
        autoplaySpeed: 2500,
        prevArrow: '<div class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
        nextArrow: '<div class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></div>',
        responsive: [{
            breakpoint: 1499,
            settings: {
                slidesToShow: 8,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 7,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 991,
            settings: {
                centerMode: !0,
                slidesToShow: 6,
                slidesToScroll: 1,
                arrows: !1
            }
        }, {
            breakpoint: 767,
            settings: {
                centerMode: !0,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: !1
            }
        }]
    })
}), $(window).on("load resize", function() {
    $(window).width() < 1024 && $(".rd-slickslider-44").slick({
        infinite: !0,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 300,
        dots: !1,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: !0,
                dots: !0
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    }), $(window).width() < 991 && $(".rd-slickslider-22").slick({
        infinite: !0,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        dots: !1
    })
}), $(window).load(function() {
    var viewportWidth = $(window).width();
    viewportWidth < 767 && $(".description-accordion").removeClass("open")
});
//# sourceMappingURL=/cdn/shop/t/16/assets/custom-rd.js.map?v=50343056199812358181685338139